import axios from "axios";
import Config from "config";
import FailedRequestError from "repository/error/FailedRequestError";
import {ApiError, NoResponseError} from "repository/errors";
import Cookies from "js-cookie";

const Api = axios.create({
    baseURL: Config.api,
    // Every request gives up after 60 s (R40). A caller can pass its own `timeout`, as the converting listing GET does.
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Middleware that refreshes jwt from Cookies before every request.ß
 */
Api.interceptors.request.use(
    config => {
        const token = Cookies.get("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete Api.defaults.headers.common.Authorization;
        }
        return config;
    },
    error => Promise.reject(error)
);

/**
 * Every failed request rejects with a typed error (R64). The axios error itself never leaves here: it carries the Authorization header.
 */
Api.interceptors.response.use(
    res => res,
    err => {
        if (err.response) {
            // The server responded with a status code out of the range 2xx
            const apiError = ApiError.fromResponse(err);
            if (apiError.status === 401) {
                window.location = Config.dashboard;
            }
            throw apiError;
        }
        if (err.config) {
            // The request was made and no response came back: a timeout, a dropped connection, or an nginx/Cloudflare answer without CORS
            // headers (413, 502, 504, 52x), which the browser hides from the page. axios sets ECONNABORTED on a timeout (and on an abort).
            throw new NoResponseError({url: err.config.url, method: err.config.method, timedOut: err.code === 'ECONNABORTED'});
        }
        // Something happened in setting up the request that triggered an Error
        throw new FailedRequestError("Could not make request");
    }
)

export const ping = async () => {
    try {
        await fetch('https://api.speedweaver.co.uk', {mode: 'no-cors'});
        return true;
    } catch (e) {
        return false;
    }
}

export default Api;